<template>
  <div id="teleport-footer"> </div>
</template>

<style lang="scss" scoped src="./Footer.scss"></style>
